import React from 'react';
import ReactDOM from 'react-dom'; // Không dùng 'react-dom/client' trong React 16
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
